import { render, staticRenderFns } from "./BasicTaskForm.vue?vue&type=template&id=2846bacf&scoped=true"
import script from "./BasicTaskForm.vue?vue&type=script&lang=js"
export * from "./BasicTaskForm.vue?vue&type=script&lang=js"
import style0 from "./BasicTaskForm.vue?vue&type=style&index=0&id=2846bacf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846bacf",
  null
  
)

export default component.exports